import React from 'react';

function Certificate({ data }){
        let issuedOn = new Date(data.issuedOn).toDateString();
        return(
            <div className='cert' id='certificate'
                    style={{ 
                        background: "url('/assets/certificate/left.png')",
                        backgroundSize: '100% 100%'
                    }} >
                <img 
                    src='/assets/certificate/bottom.png' 
                    alt='bottom'
                    className='cert--bottom'
                    />
                <img 
                    src='/assets/certificate/top.png' 
                    alt='top'
                    className='cert--top'
                    />
                <img
                    src="/assets/certificate/logo.png" 
                    alt="business toys logo"
                    className='cert--logo'
                />
                <div className='cert__qr' >
                    <img src={data.qrCode} alt='qr-code' />
                </div>
                <div className='cert__content'>
                    <h2>Certificate</h2>
                    <h4>This is to Certify</h4>
                    <h3>{data.name}</h3>
                    <p>
                        has successfully completed the prescribed requirements <br />
                        including practical and projects for the award of <strong>{data.duration}</strong> 
                    </p>
                    <h1>{data.course} Certification Program.</h1>
                    <div className='cert__content__inner' >
                        <div className='cert__content__inner--date' >
                            Issued On <br />
                            <span>
                                {issuedOn}
                            </span>
                        </div>
                        <div className='cert__content__inner__ribbion' >
                            <img src='/assets/certificate/ribbion.png' alt='certified' />
                        </div>
                        <div className='cert__content__inner--sign' >
                            Digitally Signed & Authorized by <br />
                            <span>
                                Mr. Manikanta Prasad <br />
                            </span>
                            Chief Mentor, Business Toys Pvt. Ltd.
                        </div>
                    </div>
                </div>
            </div>
        )
};

export default Certificate;